(function () {
  function fixBrushOnAutopilot() {
    if (window.innerWidth <= 960) return;

    var cont = document.querySelector('.brush-on-autopilot .content');
    if (!cont) return;

    var img = cont.querySelector('.image img');
    var text = cont.querySelector('.text');
    if (img && text) {
      cont.style.width = (img.offsetWidth + text.offsetWidth * 2) + 'px';
    }
  }

  document.addEventListener('DOMContentLoaded', fixBrushOnAutopilot);
  window.addEventListener('resize', fixBrushOnAutopilot);
})();
